module.exports = __webpack_public_path__ + "static/media/featurePin.86690212.svg";